<template>
  <div class="app-content">
    <Navbar />
    <div class="">
      <div
        class="w-full flex flex-wrap justify-center items-center text-white"
        style="min-height: 80vh"
      >
        <div class="h-100 px-10 lg:flex items-center justify-center">
          <div class="text-center lg:text-left lg:w-2/5 px-10 lg:px-32">
            <h1
              class="text-3xl md:text-4xl lg:text-4xl mb-5 md:mb-0 leading-none font-bold"
            >
              SPYOWS Academy
            </h1>

            <div class="w-full mt-8 text-center md:-ml-6">
              <router-link class="btn" to="/about">
                Get Started
              </router-link>
            </div>
          </div>
          <div class="right lg:w-3/5 text-lg mt-10 lg:mt-0">
            <p class="font-bold">
              Take a look at some of these videos to learn about using
              <strong>Robinhood</strong>
            </p>
            <br />
            <ol class="list-decimal list-inside">
              <li>
                <a href="https://www.youtube.com/watch?v=xY9HyMAizm4"
                  ><u>How to Trade Options on Robinhood</u>
                </a>
              </li>
              <li>
                <a href="https://www.youtube.com/watch?v=SD7sw0bf1ms&amp;t=387s"
                  ><u
                    >How to Trade options on Robinhood for Beginners in 2020</u
                  ></a
                >
              </li>
              <li>
                <a href="https://www.youtube.com/watch?v=-BqepSCjGms"
                  ><u>How to Sell calls and Puts on Robinhood</u></a
                >
              </li>
              <li>
                <a href="https://www.youtube.com/watch?v=AaemWfwYBI8"
                  ><u
                    >Robinhood App Investing 202- The ultimate Beginners
                    Guide</u
                  ></a
                >
              </li>
            </ol>
            <br />
            <p class="font-bold">
              How to open a Robinhood Account and trade options
            </p>
            <ol class="list-decimal list-inside">
              <li>
                <a href="https://www.youtube.com/watch?v=kWcw0wu7Rug"
                  ><u>Robinhood App-Setup Tutorial for Robinhood</u></a
                >
              </li>
            </ol>
            <br />
            <p>
              In this video, please make sure you click YES for Options
              trading.<br />
              You should also choose Expert on experience.
            </p>
            <!-- <img
              @click="showModal = true"
              src="/images/youtube.png"
              class="max-w-10 md:max-w-none hover:opacity-75 cursor-pointer"
              alt=""
            /> -->
          </div>
        </div>
      </div>
    </div>

    <Footer>Learn from the best</Footer>

    <modal v-if="showModal" width="full" @close="showModal = false">
      <div class="h-full w-full relative p-20">
        <!-- The video -->
        <video autoplay muted loop id="myVideo">
          <source
            src="https://res.cloudinary.com/strategyhut/video/upload/v1582200284/ATIGS-2018-Highlight-Video_cbmyla.mp4"
            type="video/mp4"
          />
        </video>
      </div>
    </modal>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from "@/components/layout/Nav.vue";
import Footer from "@/components/layout/Footer.vue";
import Modal from "@/components/Modal.vue";

export default {
  name: "Academy",
  metaInfo: {
    title: "Spyows",
    titleTemplate: "%s | About",
    htmlAttrs: {
      lang: "en",
      amp: true
    }
  },
  components: {
    Navbar,
    Modal,
    Footer
  },
  data() {
    return {
      showModal: false
    };
  }
};
</script>

<style lang="postcss" scoped>
#myVideo {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  height: auto;
}

.right a {
  @apply text-custom;
}
</style>
